import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export enum GameModeType {
	'DEMO',
	'REAL'
}

export type CasinoThemeState = {
	isInAWindow: boolean;
	gameMode: GameModeType;
	gameId: { id: string; provider: string } | null;
	gameProvider: string | null;
	closeGame: boolean;
	rebuyGame: boolean;
};

const initialState: CasinoThemeState = {
	isInAWindow: false,
	gameMode: GameModeType.REAL,
	gameId: null,
	gameProvider: null,
	closeGame: false,
	rebuyGame: false
};

export const casinoThemeSlice = createSlice({
	name: 'theme',
	initialState,
	reducers: {
		setIsInAWindowAction: (state: CasinoThemeState, action: PayloadAction<boolean>) => {
			state.isInAWindow = action.payload;
		},
		setGameModeAction: (state: CasinoThemeState, action: PayloadAction<GameModeType>) => {
			state.gameMode = action.payload;
		},
		setGameIdAction: (state: CasinoThemeState, action: PayloadAction<{ id: string; provider: string }>) => {
			state.gameId = action.payload;
		},
		setCloseGameAction: (state: CasinoThemeState, action: PayloadAction<boolean>) => {
			state.closeGame = action.payload;
		},
		setRebuyAction: (state: CasinoThemeState, action: PayloadAction<boolean>) => {
			state.rebuyGame = action.payload;
		}
	}
});

export const { setIsInAWindowAction, setGameModeAction, setGameIdAction, setCloseGameAction, setRebuyAction } =
	casinoThemeSlice.actions;

export const selectCasinoTheme = (state: RootState) => state.casinoTheme;
export default casinoThemeSlice.reducer;
